import React, { useState } from 'react';
import http from 'services/http';
import { alerta } from 'components/Alert/index';

export default function ContatoCriar(props) {
    const [nome, setNome] = useState('');
    const [telefone, setTelefone] = useState('');
    const [salvando, setSalvando] = useState(false);

    const salvar = async () => {
        if (!nome.trim()) {
            alerta({ success: false, message: 'Informe o nome do cliente!' });
            return;
        }
        if (!telefone.trim()) {
            alerta({ success: false, message: 'Informe o telefone do cliente!' });
            return;
        }

        setSalvando(true);
        try {
            const response = await http.post('/clientes', { nome: nome.trim(), telefone: telefone.trim() });
            alerta(response.data);
            props.history.push('/contatos');
        } catch (e) {
            alerta(e.response?.data ?? { success: false, message: 'Erro ao salvar cliente.' });
            setSalvando(false);
        }
    };

    return (
        <div className="bordered">
            <div>
                <div className="titulo-principal">
                    Novo Contato
                </div>

                <div className="btn-group caixa-inputs p-b">
                    <div className="input-criacao-usuario margin-vertical-30">
                        <label className="titulo-input-criacao">Nome:</label>
                        <input
                            required
                            type="text"
                            maxLength="120"
                            className="form-control input-dados-criar"
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                        />
                    </div>

                    <div className="input-criacao-usuario margin-vertical-30">
                        <label className="titulo-input-criacao">Telefone:</label>
                        <input
                            required
                            type="text"
                            maxLength="20"
                            placeholder="(11) 99999-9999"
                            className="form-control input-dados-criar"
                            value={telefone}
                            onChange={(e) => setTelefone(e.target.value)}
                        />
                    </div>
                </div>

                <div
                    style={{ padding: '0 10px', justifyContent: 'left' }}
                    className="d-flex m-b m-t"
                >
                    <button
                        style={{ display: 'block', width: '270px', marginLeft: '150px' }}
                        className="btn btn-success"
                        disabled={salvando}
                        onClick={salvar}
                    >
                        {salvando ? 'Salvando...' : 'Salvar'}
                    </button>
                </div>
            </div>
        </div>
    );
}
